exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lds-ring[data-v-5766332c]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;position:absolute;height:100%;top:50%;left:50%;-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.lds-ring div[data-v-5766332c]{box-sizing:border-box;display:block;position:absolute;width:60%;height:60%;margin:8px;border:8px solid;border-radius:50%;animation:lds-ring-data-v-5766332c 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#fff transparent transparent}.lds-ring div[data-v-5766332c]:first-child{animation-delay:-.45s}.lds-ring div[data-v-5766332c]:nth-child(2){animation-delay:-.3s}.lds-ring div[data-v-5766332c]:nth-child(3){animation-delay:-.15s}@keyframes lds-ring-data-v-5766332c{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5766332c","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppButtonNew/spinner.vue
// module id = 863a3a725ac2ed3a13ec
// module chunks = 0